export default __webpack_public_path__ + "static/media/it.f4faf463.svg";